import { useEffect, useState } from "react";
import { http } from "../api";
import { ScrollText } from "lucide-react";
import { PageHeader, EmptyState, PersonLink } from "../shared";

const actionTone = { create: "green", update: "blue", delete: "red", login: "amber", export: "blue", import: "blue", register: "green" };

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/audit").then((r) => setRows(r.data)); }, []);

  return (
    <>
      <PageHeader eyebrow="GOVERNANCE" title="Audit log" subtitle={`${rows.length} tracked events across the workspace`} />
      <section className="panel">
        {rows.length === 0 ? <EmptyState icon={ScrollText} title="No audit records" hint="System activity will appear here." /> : (
          <div className="audit-list">
            {rows.map((a, i) => (
              <div key={a.audit_id} className="audit-row" data-testid={`audit-row-${i}`}>
                <span className={`chip ${actionTone[a.action] || "blue"}`}>{a.action}</span>
                <div>
                  <PersonLink contactId={a.actor_contact_id} name={a.user_name} testid={`audit-actor-${i}`}><b>{a.user_name}</b></PersonLink> <span className="hint">→ {a.entity} {a.entity_id !== "-" ? `#${a.entity_id}` : ""}</span>
                  <small>{new Date(a.created_at).toLocaleString()} {Object.keys(a.meta || {}).length ? "· " + JSON.stringify(a.meta) : ""}</small>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
